
import { CopilotMessage, CopilotAssistant } from '../types/database-types';
import { MessageDisplay } from '../types/chat-hook-types';

/**
 * Transforms a CopilotMessage to MessageDisplay format
 * Extracts assistant data from metadata and places it at the top level
 * Preserves database ID for backend operations
 */
export function transformCopilotMessageToDisplay(message: CopilotMessage): MessageDisplay {
  // Extract assistant from metadata if it exists
  const assistantFromMetadata = message.metadata?.assistant as CopilotAssistant | undefined;
  
  return {
    ...message,
    databaseId: message.id, // Store database ID separately for backend operations
    assistant: assistantFromMetadata || null,
    isPending: false,
    isLoading: false
  };
}

/**
 * Transforms an array of CopilotMessages to MessageDisplay format
 */
export function transformCopilotMessagesToDisplay(messages: CopilotMessage[]): MessageDisplay[] {
  return messages.map(transformCopilotMessageToDisplay);
}

/**
 * Creates a new user message in MessageDisplay format
 */
export function createUserMessageDisplay(
  content: string, 
  threadId: string,
  tempId?: string
): MessageDisplay {
  return {
    id: tempId || `temp-${Date.now()}`,
    threadId,
    role: 'user',
    content,
    createdAt: new Date().toISOString(),
    metadata: {},
    assistant: null,
    isPending: false,
    isLoading: false
  };
}

/**
 * Creates a loading assistant message in MessageDisplay format
 */
export function createLoadingAssistantMessage(
  threadId: string,
  assistant?: CopilotAssistant | null
): MessageDisplay {
  return {
    id: `loading-${Date.now()}`,
    threadId,
    role: 'assistant',
    content: '',
    createdAt: new Date().toISOString(),
    metadata: {},
    assistant: assistant || null,
    isPending: true,
    isLoading: true
  };
}
